import { graphql } from 'gql';

export const isUniqueActKC3InternalNumberGql = graphql(`
    query uerIsUniqueActKC3InternalNumber($actKC3Id: Long, $actKC3Number: Long!, $contractId: Long!) {
        uerIsUniqueActKC3InternalNumber(actKC3Id: $actKC3Id, actKC3Number: $actKC3Number, contractId: $contractId) {
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const createActKC3Gql = graphql(`
    mutation uerCreateActKC3($actKC3Input: ActKC3Input!) {
        uerCreateActKC3(actKC3Input: $actKC3Input) {
            data {
                id
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateActKC3Gql = graphql(`
    mutation uerUpdateActKC3($actKC3Input: ActKC3UpdateInput!) {
        uerUpdateActKC3(actKC3Input: $actKC3Input) {
            data {
                id
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerActKC3ActsKC2SelectionListGql = graphql(`
    query uerActKC3ActsKC2SelectionList(
        $skip: Int
        $take: Int
        $contractId: Long!
        $actKC3Id: Long
        $where: ActKC3ActsKC2SelectionItemFilterInput
        $order: [ActKC3ActsKC2SelectionItemSortInput!]
        $rootContractObjectId: Long
        $workOrderId: Long
    ) {
        uerActKC3ActsKC2SelectionList(
            skip: $skip
            take: $take
            contractId: $contractId
            actKC3Id: $actKC3Id
            where: $where
            order: $order
            rootContractObjectId: $rootContractObjectId
            workOrderId: $workOrderId
        ) {
            items {
                actKC2CorrectionNumber
                actKC2CostGroup
                actKC2Date
                actKC2FinishDate
                actKC2FullNumber
                actKC2Id
                actKC2IsCorrection
                actKC2IsCorrectionOfActKC3
                actKC2IsIncludedToPrimaryActKC3
                actKC2IsInactive
                actKC2Number
                actKC2StartDate
                actKC2Status
                constructionTypeId
                constructionTypeName
                constructionTypeShortName
                contractId
                contractObjectId
                contractObjectName
                isSelected
                workOrderDate
                workOrderId
                workOrderInternalNumber
                workOrderName
                workOrderObjectId
                workOrderStatus
                workOrderSubject
            }
        }
    }
`);

export const uerActKC3Gql = graphql(`
    query uerActKC3($actKC3Id: Long!) {
        uerActKC3(actKC3Id: $actKC3Id) {
            data {
                id
                contractId
                number
                date
                reportingStartDate
                reportingFinishDate
                actKC2Ids
                isCorrection
                isInactive
                correctionNumber
                fullNumber
            }
        }
    }
`);

export const exportActKC3AsExcelGql = graphql(`
    query uerExportActKC3AsExcel($actKC3Id: Long!, $includeOtherDetails: Boolean!) {
        uerExportActKC3AsExcel(actKC3Id: $actKC3Id, includeOtherDetails: $includeOtherDetails) {
            data {
                count
                dataUrl
                name
                size
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerActKC3ActsKC2ActKC2NumberFilterGql = graphql(`
    query uerActKC3ActsKC2ActKC2NumberFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $actKC3Id: Long
        $where: FilterValueContainerOfStringFilterInput
        $order: [FilterValueContainerOfStringSortInput!]
        $rootContractObjectId: Long
        $workOrderId: Long
    ) {
        uerActKC3ActsKC2ActKC2NumberFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            actKC3Id: $actKC3Id
            where: $where
            order: $order
            rootContractObjectId: $rootContractObjectId
            workOrderId: $workOrderId
        ) {
            items {
                id
                value
            }
        }
    }
`);

export const uerActKC3ActsKC2ActKC2DateFilterGql = graphql(`
    query uerActKC3ActsKC2ActKC2DateFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $actKC3Id: Long
        $where: FilterValueOfNullableOfDateOnlyFilterInput
        $order: [FilterValueOfNullableOfDateOnlySortInput!]
        $rootContractObjectId: Long
        $workOrderId: Long
    ) {
        uerActKC3ActsKC2ActKC2DateFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            actKC3Id: $actKC3Id
            where: $where
            order: $order
            rootContractObjectId: $rootContractObjectId
            workOrderId: $workOrderId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerActKC3ActsKC2ActKC2CostGroupFilterGql = graphql(`
    query uerActKC3ActsKC2ActKC2CostGroupFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $actKC3Id: Long
        $where: FilterValueOfCostGroupEnumFilterInput
        $order: [FilterValueOfCostGroupEnumSortInput!]
        $rootContractObjectId: Long
        $workOrderId: Long
    ) {
        uerActKC3ActsKC2ActKC2CostGroupFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            actKC3Id: $actKC3Id
            where: $where
            order: $order
            rootContractObjectId: $rootContractObjectId
            workOrderId: $workOrderId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerActKC3ActsKC2ConstructionTypeIdFilterGql = graphql(`
    query uerActKC3ActsKC2ConstructionTypeIdFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $actKC3Id: Long
        $where: FilterValueOfInt32FilterInput
        $order: [FilterValueOfInt32SortInput!]
        $rootContractObjectId: Long
        $workOrderId: Long
    ) {
        uerActKC3ActsKC2ConstructionTypeIdFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            actKC3Id: $actKC3Id
            where: $where
            order: $order
            rootContractObjectId: $rootContractObjectId
            workOrderId: $workOrderId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerActKC3ActsKC2ContractObjectNameFilterGql = graphql(`
    query uerActKC3ActsKC2ContractObjectNameFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $actKC3Id: Long
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $rootContractObjectId: Long
        $workOrderId: Long
    ) {
        uerActKC3ActsKC2ContractObjectNameFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            actKC3Id: $actKC3Id
            where: $where
            order: $order
            rootContractObjectId: $rootContractObjectId
            workOrderId: $workOrderId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerActKC3ActsKC2WorkOrderInternalNumberFilterGql = graphql(`
    query uerActKC3ActsKC2WorkOrderInternalNumberFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $actKC3Id: Long
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $rootContractObjectId: Long
        $workOrderId: Long
    ) {
        uerActKC3ActsKC2WorkOrderInternalNumberFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            actKC3Id: $actKC3Id
            where: $where
            order: $order
            rootContractObjectId: $rootContractObjectId
            workOrderId: $workOrderId
        ) {
            items {
                value
            }
        }
    }
`);
